import request from '../../../shared/request'

export function getLeadRFIs(lead_id) {
  return request(`/lead/rfis/${lead_id}/`)
}

export function getRFIData(rfi_id) {
  return request(`/lead/rfis/${rfi_id}/info`)
}

export function createLeadRFI(payload) {
  return request(`/lead/rfis/${payload.rfi_data.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadRFI(payload) {
  return request(`/lead/rfis/${payload.rfi_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadRFI(payload) {
  return request(`/lead/rfis/${payload.rfiId}/?leadId=${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// attachments
export function uploadAttachments(payload) {
  return request(`/lead/rfis/${payload.leadRfiId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(leadRfiId) {
  return request(`/lead/rfis/${leadRfiId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/lead/rfis/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/lead/rfis/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/rfis.js